/* eslint-disable no-param-reassign */
const _ = require('lib/underscore')
const log = require('log').create('deep defaults') // eslint-disable-line


function deep_defaults(input, defaults, options) {
    // TODO signup/finalize test is triggering an error by passing some
    // undefined input. ignoring undefined input for now. need to see if this is
    // just a test issue
    if (! input) return input

    if (_.isArray(input)) return input

    // create local copy of defaults so we can delete keys we don't need
    defaults = _.clone(defaults)

    options = options || {}
    _.defaults(options, {
        add_undefined_objects: true,
    })

    // find all objects in the defaults object
    // and apply deep_defaults to them first, recursively
    _.each(_.keys(defaults), function applyDefaults(key) {

        // if defaults.key is an object, but input.key is undefined
        if (_.isUndefined(input[key]) && _.isObject(defaults[key])) {
            if (options.add_undefined_objects) {
                // make sure input.key is an object ready to receive properties from defaults.key
                input[key] = {}
            } else {
                // don't add default objects that are undefined in the input
                delete defaults[key]
            }
        }

        if (_.isObject(input[key]) && _.isObject(defaults[key])) {
            // object.key is an object in both objects
            deep_defaults(input[key], defaults[key], options)

        } else {
            // ignore non-object keys that aren't in the whitelist, if provided
            if (options.whitelist) {
                if (! _.contains(options.whitelist, key)) {
                    delete defaults[key]
                }
            }
        }
    })

    return _.defaults(input, defaults)
}

module.exports = deep_defaults
